module.exports = __webpack_public_path__ + "static/media/12.37c5dd0c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/12.mp3
// module id = 488
// module chunks = 0